import React, { lazy, memo } from 'react';
export function ResultSeasonal() {
  return <section className="bg-warm-light py-16 md:py-20 px-4" data-id="element-240">
      <div className="max-w-3xl mx-auto text-center" data-id="element-241">
        <p className="font-sans font-medium text-soft-gold uppercase tracking-wider text-xs md:text-sm mb-3" data-id="element-242">
          Turn everyday moments into beautiful memories
        </p>

        <div className="mb-8 rounded-2xl overflow-hidden shadow-xl max-w-3xl mx-auto" data-id="element-243">
          <img src="https://images.unsplash.com/photo-1534361960057-19889db9621e?w=800&h=400&fit=crop&crop=faces,center&q=80" alt="Happy scruffy mixed-breed dog at the beach during golden hour, warm cinematic light, gentle waves and soft breeze in fur, a meaningful moment worth saving forever" className="w-full h-auto object-cover aspect-[2/1]" loading="lazy" decoding="async" width={800} height={400} data-id="element-244" />
        </div>

        <p className="font-sans text-lg md:text-xl text-gray-800 max-w-2xl mx-auto leading-relaxed" data-id="element-245">
          Create photos that feel{' '}
          <span className="font-semibold text-warm-hero" data-id="element-246">
            warm, meaningful, and worth saving
          </span>{' '}
          long after the moment is gone.
        </p>
      </div>
    </section>;
}